import { useMemo } from 'react'
import { useBrandVisualKits } from 'hooks/queries/workspaces/useBrandVisualKits'
import Color from 'colorjs.io'

export const useBrandKitColors = () => {
  const brandVisualKits =
    useBrandVisualKits({ cacheTime: 60 * 60 * 1000, staleTime: 60 * 60 * 1000 }).data?.brand_visual_kits || []
  const lastBrandVisualKit = brandVisualKits
    .slice()
    .reverse()
    .find((visualKit) => visualKit.primary_color_palette.colors.length > 0)
  const brandKitColors = useMemo(
    () =>
      lastBrandVisualKit?.primary_color_palette.colors
        .map((color) => color.hex)
        .filter((c) => {
          // Filter out colors that are too light and close to white
          const color = new Color(c)
          const lch = color.to('lch')

          return lch.l < 95 && lch.c > 5
        }),
    [lastBrandVisualKit?.primary_color_palette.colors],
  )

  return brandKitColors
}
